<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <!-- Chat Storm: Centraliza tabs quando há apenas 2 itens (agentes sem tab "Todos") -->
  <!-- Chat Storm: [&_ul]:min-w-0 permite que as tabs encolham dentro da largura da
       lista de conversas em vez de aparecer a rolagem horizontal com setas -->
  <woot-tabs
    :index="activeTabIndex"
    class="w-full px-3 -mt-1 py-0 [&_ul]:p-0 [&_ul]:min-w-0 [&_ul]:w-full h-10"
    :class="
      items.length <= 2 ? '[&_ul]:justify-center' : '[&_ul]:justify-between'
    "
    @change="onTabChange"
  >
    <!-- Chat Storm: tamanho fixo em px (nao acompanha a fonte do usuario nem a
         largura da tela), para as abas ficarem sempre iguais e sem rolagem -->
    <woot-tabs-item
      v-for="(item, index) in items"
      :key="item.key"
      class="[&_a]:!text-[13px] [&_a]:font-medium !flex-shrink min-w-0 !mx-0"
      :class="items.length <= 2 ? 'flex-1 [&_a]:justify-center' : ''"
      :index="index"
      :name="item.name"
      :count="item.count"
      is-compact
    />
  </woot-tabs>
</template>
